// Star progress for football, persisted to localStorage.
// Schema: { stars: { [levelId]: 0|1|2|3 } } — 0 means attempted but not solved.

const KEY = "arcade:football:progress";

interface Progress {
  stars: Record<number, number>;
}

const empty = (): Progress => ({ stars: {} });

export const load = (): Progress => {
  if (typeof localStorage === "undefined") return empty();
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return empty();
    const parsed = JSON.parse(raw) as Progress;
    return parsed && typeof parsed.stars === "object" ? parsed : empty();
  } catch {
    return empty();
  }
};

const save = (p: Progress) => {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(KEY, JSON.stringify(p));
  } catch {
    // localStorage full or disabled — silently fail
  }
};

export const recordStars = (levelId: number, stars: number) => {
  const p = load();
  const prev = p.stars[levelId] ?? 0;
  if (stars > prev) {
    p.stars[levelId] = stars;
    save(p);
  }
};

export const starsFor = (levelId: number): number => load().stars[levelId] ?? 0;

// A level is unlocked if any prior level has at least 1 star (or it's level 1).
export const isUnlocked = (levelId: number): boolean => {
  if (levelId <= 1) return true;
  return (load().stars[levelId - 1] ?? 0) > 0;
};
